<template lang="pug">
.error-404.text-large
  .error-404__message 404エラーが発生しました。
  a(:href='returnPage') 戻る
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Error404 extends Vue {
  private get returnPage(): string {
    return this.$bcbtCookies.returnUrl.get()
  }
}
</script>

<style lang="stylus" scoped>
.error-404
  margin 50px

  &__message
    margin-bottom 20px
</style>
